import React from 'react';
import {
  Modal,
  IconButton,
  Spinner,
  SpinnerSize,
  MessageBar,
  MessageBarType,
} from '@fluentui/react';
import { RenderedEmail } from '../../models/EmailTemplate';
import { styles } from './EmailTemplateAdmin.styled';

interface EmailTemplatePreviewProps {
  isOpen: boolean;
  onClose: () => void;
  previewResult: RenderedEmail | null;
  loading: boolean;
  error: string | null;
}

export const EmailTemplatePreview: React.FC<EmailTemplatePreviewProps> = ({
  isOpen,
  onClose,
  previewResult,
  loading,
  error,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onClose}
      isBlocking={false}
      styles={{
        main: {
          maxWidth: '700px',
          width: '90vw',
          maxHeight: '80vh',
        },
        scrollableContent: {
          overflow: 'auto',
        },
      }}
    >
      <div className={styles.previewModal}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: 600, color: '#323130', margin: 0 }}>
            Email Preview
          </h2>
          <IconButton
            iconProps={{ iconName: 'Cancel' }}
            onClick={onClose}
            ariaLabel="Close preview"
          />
        </div>

        {loading && (
          <div className={styles.loadingContainer}>
            <Spinner size={SpinnerSize.large} label="Generating preview..." ariaLabel="Loading preview" />
          </div>
        )}

        {error && (
          <MessageBar messageBarType={MessageBarType.error} styles={{ root: { marginBottom: '12px' } }}>
            {error}
          </MessageBar>
        )}

        {!loading && previewResult && (
          <>
            <div className={styles.previewField}>
              <span className={styles.previewFieldLabel}>Subject:</span>
              <span className={styles.previewFieldValue}>{previewResult.subject}</span>
            </div>
            <div className={styles.previewField}>
              <span className={styles.previewFieldLabel}>To:</span>
              <span className={styles.previewFieldValue}>{previewResult.to}</span>
            </div>
            <div className={styles.previewField}>
              <span className={styles.previewFieldLabel}>CC:</span>
              <span className={styles.previewFieldValue}>
                {previewResult.cc.length > 0 ? previewResult.cc.join(', ') : 'None'}
              </span>
            </div>
            <div className={styles.previewField}>
              <span className={styles.previewFieldLabel}>BCC:</span>
              <span className={styles.previewFieldValue}>
                {previewResult.bcc.length > 0 ? previewResult.bcc.join(', ') : 'None'}
              </span>
            </div>
            <iframe
              className={styles.previewBody}
              title="Email body preview"
              srcDoc={previewResult.body}
              sandbox=""
              aria-label="Email body preview"
            />
          </>
        )}

        {!loading && !previewResult && !error && (
          <div className={styles.emptyState}>
            <span>No preview data available.</span>
          </div>
        )}
      </div>
    </Modal>
  );
};
